export const scalars = {
  AudienceBuilderGeographyId: 'string',
  BigInt: 'string',
  Date: 'string',
  DateTime: 'string',
  Email: 'string',
  JSON: '{ [key: string]: any }',
  Time: 'string',
};
